import { ConfigModel } from '../core/interfaces/config';
import { CustomerService } from '../core/services/customer.service';

export class MenuConfig implements ConfigModel {
	public config: any = {};

	constructor() {
		var company = new CustomerService();
		if (company.settings.name != "sef") {

			this.config = {

				aside: {
					self: {},
					items: [
						{
							title: 'Ana Sayfa',
							desc: '',
							root: true,
							bullet: 'dot',
							translate: 'MENU.DASHBOARD',
							submenu: [
								{
									title: 'Ana Sayfa',
									icon: 'fa fa-home fa-fw',
									page: '/home',
									translate: 'MENU.DASHBOARD'
								},
							]
						},
						{
							title: 'Defter İşlemleri',
							desc: '',
							root: true,
							bullet: 'dot',
							translate: 'MENU.DEFTER.ROOT',
							submenu: [
								{
									title: 'Defter Listesi',
									icon: 'fa fa-file fa-fw',
									page: '/company/defter/list',
									translate: 'MENU.DEFTER.LIST'
								},
								{
									title: 'Kaynak Veri Yükle',
									icon: 'fa fa-upload fa-fw',
									page: '/company/defter/add',
									translate: 'MENU.DEFTER.ADD'
								},
							]
						},
						{
							title: 'Şirket İşlemleri',
							desc: '',
							root: true,
							bullet: 'dot',
							translate: 'MENU.COMPANY.ROOT',
							submenu: [
								{
									title: 'Şirket Listesi',
									icon: 'fa fa-building fa-fw',
									page: '/company/list',
									translate: 'MENU.COMPANY.LIST'
								},
								{
									title: 'Şube Listesi',
									icon: 'fa fa-building fa-fw',
									page: '/company/branch/list',
									translate: 'MENU.BRANCH.LIST'
								},
							]
						},
						{
							title: 'Mükellef Sorumlu İşlemleri',
							desc: '',
							root: true,
							bullet: 'dot',
							translate: 'MENU.MUKELLEF.ROOT',
							submenu: [
								{
									title: 'Mükellef Sorumlu Listesi',
									icon: 'fa fa-user-tie fa-fw',
									page: '/company/mukellefsorumlu/list',
									translate: 'MENU.MUKELLEF.LIST'
								},
							]
						},
						{
							title: 'Duyuru İşlemleri',
							desc: '',
							root: true,
							bullet: 'dot',
							translate: 'MENU.ANNOUNCEMENT.ROOT',
							submenu: [
								{
									title: 'Duyuru Listesi',
									icon: 'fa fa-bullhorn fa-fw',
									page: '/announcement/list',
									translate: 'MENU.ANNOUNCEMENT.LIST'
								},
							]
						},
						{
							title: 'Kullanıcı İşlemleri',
							desc: '',
							root: true,
							bullet: 'dot',
							translate: 'MENU.USER.ROOT',
							submenu: [
								{
									title: 'Kullanıcı Listesi',
									icon: 'fa fa-user fa-fw',
									page: '/user/list',
									translate: 'MENU.USER.LIST'
								},
							]
						},
						{
							title: 'Ayarlar',
							desc: '',
							root: true,
							bullet: 'dot',
							translate: 'MENU.SETTING',
							submenu: [
								{
									title: 'Ayarlar',
									icon: 'fa fa-cogs fa-fw',
									page: '/settings',
									translate: 'MENU.SETTING'
								},
							]
						},
					]
				}
			};
		}
		else {
			this.config = {
				aside: {
					self: {},
					items: [
						{
							title: 'Anasayfa',
							desc: '',
							root: true,
							translate: 'MENU.DASHBOARD',
							submenu: [
								{
									title: 'Anasayfa',
									page: '/',
									icon: 'Anasayfa',
									translate: 'MENU.DASHBOARD'
								},
							]
						},
						{
							title: 'Defter İşlemleri',
							desc: '',
							root: true,
							translate: 'MENU.DEFTER.ROOT',
							submenu: [
								{
									title: 'Defter Listesi',
									page: '/company/defter/list',
									icon: 'Group 1477',
									translate: 'MENU.DEFTER.LIST'
								},
								{
									title: 'Kaynak Veri Yükle',
									icon: 'fa fa-upload fa-fw',
									page: '/company/defter/add',
									translate: 'MENU.DEFTER.ADD'
								},
							]
						},
						{
							title: 'Şirket İşlemleri',
							desc: '',
							root: true,
							translate: 'MENU.COMPANY.ROOT',
							submenu: [
								{
									title: 'Şirket Listesi',
									page: '/company/list',
									icon: 'En Yakın Şube _ ATM',
									translate: 'MENU.COMPANY.LIST'
								},
								{
									title: 'Şube Listesi',
									page: '/company/branch/list',
									icon: 'En Yakın Şube _ ATM',
									translate: 'MENU.BRANCH.LIST'
								},
							]
						},
						{
							title: 'Mükellef Sorumlu İşlemleri',
							desc: '',
							root: true,
							translate: 'MENU.MUKELLEF.ROOT',
							submenu: [
								{
									title: 'Mükellef Sorumlu Listesi',
									page: '/company/mukellefsorumlu/list',
									icon: 'Müşteri Ol',
									translate: 'MENU.MUKELLEF.LIST'
								},
							]
						},
						{
							title: 'Duyuru İşlemleri',
							desc: '',
							root: true,
							translate: 'MENU.ANNOUNCEMENT.ROOT',
							submenu: [
								{
									title: 'Duyuru Listesi',
									page: '/announcement/list',
									icon: 'Group 2567',
									translate: 'MENU.ANNOUNCEMENT.LIST'
								},
							]
						},
						{
							title: 'Kullanıcı İşlemleri',
							desc: '',
							root: true,
							translate: 'MENU.USER.ROOT',
							submenu: [
								{
									title: 'Kullanıcı Listesi',
									page: '/user/list',
									icon: 'Profilim',
									translate: 'MENU.USER.LIST'
								},
							]
						},
					]
				}
			};
		}
	}
}
